module.exports = __webpack_public_path__ + "img/epr.98e06ee7.webp";